import { render } from "./ModalNewSession.vue?vue&type=template&id=104cb88c"
import script from "./ModalNewSession.vue?vue&type=script&lang=js"
export * from "./ModalNewSession.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__